import React from 'react';
import Icon from 'react-native-vector-icons/MaterialCommunityIcons';
import {StyleSheet} from 'react-native';

import { TYPE, FONTS } from 'style/typography';

const NotificationIcon = (props) => {
  return (
    <Icon type="MaterialCommunityIcons" style={[styles.iconArea]} name="chat" />
  );
};

const styles = StyleSheet.create({
  iconArea: {
    fontSize: TYPE['2xl'],
    fontFamily: FONTS.body,
    color: '#ffffff',
    margin: 10,
  },
});

export default NotificationIcon;
